module.exports = __webpack_public_path__ + "static/img/m_name.3807a81.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/bn/m_name.png
// module id = NC4J
// module chunks = 7